function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

export { _nonIterableSpread as default };
//# sourceMappingURL=nonIterableSpread.js.map
